import Component from '../abstracts/Component';

export default class CartLayerLogic extends Component {
  get SELECTORS() {
    return {
      main: '.js-minicart',
      content: '.l-q-c__items-container',
      remove: '.js-removeitem',
      totalPrice: '.js-total-price'
    };
  }

  constructor(component) {
    super();
    this.CartLayerComponent = component;
    this.main = document.querySelectorAll(this.SELECTORS.main);
  }

  bindEvents() {
    //this.$on('click.removeProduct', this.SELECTORS.remove, this.removeProduct);
    this.$on(this.$customEvents.MINICART_EVENTS.open, this.updateMinicart, window, null, this);
    this.$on('click.remove', this.removeProduct, 'body', this.SELECTORS.remove, this);

    //this.$emit(this.$customEvents.MINICART_EVENTS.open, {content: 'quickcart', ctx: this});
  }

  updateMinicart(e) {
    let ctx = e.event.data;
    let el = ctx.main[0];
    if (e.payload.content != 'quickcart') return false;
    ctx
      .$doAjax({
        dataType: 'html',
        url: el.dataset.href
      })
      .done(html => {
        ctx.log('Minicart updated...');

        const container = $(html).find('.l-q-c__items-container');
        const button = $(html).find('.l-q-c__checkout');
        const typeView = $(html).data('menuLayerView');

        $('.l-q-c__items-container').replaceWith(container);
        $('.l-q-c__checkout').replaceWith(button);
        if(typeView === 'large') $('.l-quick-cart').addClass('large-view');

        ctx.$emit(ctx.$customEvents.LOAD_COMPONENT.simplebar, {ctx: ctx});
        ctx.CartLayerComponent.counterList();
      })
      .fail(xhr => {
        ctx.log(`cart add error`);
        ctx.log(xhr);
      })
      .always(() => {

      });
  }

  removeProduct(e) {
    let ctx = e.event.data;
    let el = e.event.currentTarget;

    ctx
      .$doAjax({
        url: el.dataset.href,
        dataType: 'json',
        type: 'POST',
        async: false
      })
      .done(data => {
        if (data.status != 'success') {
          ctx.log("error removing entry n. " + data.entryNumber);
          return;
        }

        ctx.log('Minicart updated...');
        const code = el.dataset.code;
        $(ctx.SELECTORS.totalPrice).text(data.totalFormattedPrice);

        const itemContainer = $(el).parent(`.l-q-c__item[data-code='${code}']`);
        itemContainer.remove();

        if (data.count == 0)
          $('.js-to-checkout').toggleClass('d-none');
        ctx.CartLayerComponent.setDataQty(data.count);
      })
      .fail(xhr => {
        ctx.log(`cart add error`);
        ctx.log(xhr);
      })
      .always(() => {

      });
  }

  render() {
    this.log('Load logics...');
    this.bindEvents();
  }
}
